module.exports = __webpack_public_path__ + "img/id.521d62f5.svg";